// extracted by mini-css-extract-plugin
export default {"content":"app-modal_content__Fn5ku","cancelButton":"app-modal_cancelButton__lxHqi","primaryButton":"app-modal_primaryButton__vZAZX"};